/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TileService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Purge Tile Cache
     * @returns any Successful Response
     * @throws ApiError
     */
    public purgeTileCache(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/tile/purge',
        });
    }

}
